import { configureStore } from '@reduxjs/toolkit';

import alertReducer from './alert';
import projectReducer from './project';
import bidReducer from './bid';

const store = configureStore({
  reducer: { alert: alertReducer, project: projectReducer, bid: bidReducer },
});

export default store;
